import { useMemo, useState } from 'react';
import { MAX_PERCENTAGE } from 'data/global';

export default function useProgress() {
  const [progress, setProgress] = useState(0);

  const isInProgress = useMemo(
    () => progress > 0 && progress < MAX_PERCENTAGE,
    [progress],
  );

  return { isInProgress, progress, setProgress };
}
